module.exports = __webpack_public_path__ + "img/group-10.3af01dfd.svg";